import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const CTASection = () => {
  return (
    <section data-testid="cta-section" className="section-spacing bg-gradient-to-r from-coral via-orange to-coral relative overflow-hidden">
      {/* Decorative pattern overlay */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }} />
      </div>
      
      <div className="section-container relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white font-['Outfit'] mb-6">
            Ready to Join Apollo House?
          </h2>
          <p className="text-white/90 text-lg mb-8">
            Secure your spot for the upcoming academic year. Applications are now open!
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/contact">
              <Button
                data-testid="cta-apply-btn"
                className="bg-white text-coral hover:bg-slate-100 rounded-full px-8 py-6 text-lg font-semibold shadow-lg"
              >
                Apply Now
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
            <a href="tel:016 933 4821">
              <Button
                data-testid="cta-call-btn"
                variant="outline"
                className="border-2 border-white text-white hover:bg-white/20 rounded-full px-8 py-6 text-lg font-semibold"
              >
                Call Us
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
